import { Record } from 'immutable'

export class TaxRate extends Record({
    id: undefined,
    name: undefined,
    country_id: undefined,
    type_id: undefined,
    percent: undefined,
}) {}
